/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TipjarRouteImport } from './routes/tipjar'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MigrationRouteImport } from './routes/migration'
import { Route as MathRouteImport } from './routes/math'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LinkRouteImport } from './routes/link'
import { Route as InitialSetupRouteImport } from './routes/initial-setup'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as BuildRouteImport } from './routes/build'
import { Route as AccountDeletedRouteImport } from './routes/account-deleted'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as USharingCodeRouteImport } from './routes/u.$sharingCode'
import { Route as OauthWithingsCallbackRouteImport } from './routes/oauth/withings/callback'
import { Route as OauthFitbitCallbackRouteImport } from './routes/oauth/fitbit/callback'

const TipjarRoute = TipjarRouteImport.update({
  id: '/tipjar',
  path: '/tipjar',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrationRoute = MigrationRouteImport.update({
  id: '/migration',
  path: '/migration',
  getParentRoute: () => rootRouteImport,
} as any)
const MathRoute = MathRouteImport.update({
  id: '/math',
  path: '/math',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkRoute = LinkRouteImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => rootRouteImport,
} as any)
const InitialSetupRoute = InitialSetupRouteImport.update({
  id: '/initial-setup',
  path: '/initial-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BuildRoute = BuildRouteImport.update({
  id: '/build',
  path: '/build',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDeletedRoute = AccountDeletedRouteImport.update({
  id: '/account-deleted',
  path: '/account-deleted',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const USharingCodeRoute = USharingCodeRouteImport.update({
  id: '/u/$sharingCode',
  path: '/u/$sharingCode',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthWithingsCallbackRoute = OauthWithingsCallbackRouteImport.update({
  id: '/oauth/withings/callback',
  path: '/oauth/withings/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthFitbitCallbackRoute = OauthFitbitCallbackRouteImport.update({
  id: '/oauth/fitbit/callback',
  path: '/oauth/fitbit/callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account-deleted': typeof AccountDeletedRoute
  '/build': typeof BuildRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/download': typeof DownloadRoute
  '/faq': typeof FaqRoute
  '/initial-setup': typeof InitialSetupRoute
  '/link': typeof LinkRoute
  '/login': typeof LoginRoute
  '/math': typeof MathRoute
  '/migration': typeof MigrationRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/tipjar': typeof TipjarRoute
  '/u/$sharingCode': typeof USharingCodeRoute
  '/oauth/fitbit/callback': typeof OauthFitbitCallbackRoute
  '/oauth/withings/callback': typeof OauthWithingsCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account-deleted': typeof AccountDeletedRoute
  '/build': typeof BuildRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/download': typeof DownloadRoute
  '/faq': typeof FaqRoute
  '/initial-setup': typeof InitialSetupRoute
  '/link': typeof LinkRoute
  '/login': typeof LoginRoute
  '/math': typeof MathRoute
  '/migration': typeof MigrationRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/tipjar': typeof TipjarRoute
  '/u/$sharingCode': typeof USharingCodeRoute
  '/oauth/fitbit/callback': typeof OauthFitbitCallbackRoute
  '/oauth/withings/callback': typeof OauthWithingsCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account-deleted': typeof AccountDeletedRoute
  '/build': typeof BuildRoute
  '/dashboard': typeof DashboardRoute
  '/demo': typeof DemoRoute
  '/download': typeof DownloadRoute
  '/faq': typeof FaqRoute
  '/initial-setup': typeof InitialSetupRoute
  '/link': typeof LinkRoute
  '/login': typeof LoginRoute
  '/math': typeof MathRoute
  '/migration': typeof MigrationRoute
  '/privacy': typeof PrivacyRoute
  '/settings': typeof SettingsRoute
  '/tipjar': typeof TipjarRoute
  '/u/$sharingCode': typeof USharingCodeRoute
  '/oauth/fitbit/callback': typeof OauthFitbitCallbackRoute
  '/oauth/withings/callback': typeof OauthWithingsCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account-deleted'
    | '/build'
    | '/dashboard'
    | '/demo'
    | '/download'
    | '/faq'
    | '/initial-setup'
    | '/link'
    | '/login'
    | '/math'
    | '/migration'
    | '/privacy'
    | '/settings'
    | '/tipjar'
    | '/u/$sharingCode'
    | '/oauth/fitbit/callback'
    | '/oauth/withings/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/account-deleted'
    | '/build'
    | '/dashboard'
    | '/demo'
    | '/download'
    | '/faq'
    | '/initial-setup'
    | '/link'
    | '/login'
    | '/math'
    | '/migration'
    | '/privacy'
    | '/settings'
    | '/tipjar'
    | '/u/$sharingCode'
    | '/oauth/fitbit/callback'
    | '/oauth/withings/callback'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account-deleted'
    | '/build'
    | '/dashboard'
    | '/demo'
    | '/download'
    | '/faq'
    | '/initial-setup'
    | '/link'
    | '/login'
    | '/math'
    | '/migration'
    | '/privacy'
    | '/settings'
    | '/tipjar'
    | '/u/$sharingCode'
    | '/oauth/fitbit/callback'
    | '/oauth/withings/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountDeletedRoute: typeof AccountDeletedRoute
  BuildRoute: typeof BuildRoute
  DashboardRoute: typeof DashboardRoute
  DemoRoute: typeof DemoRoute
  DownloadRoute: typeof DownloadRoute
  FaqRoute: typeof FaqRoute
  InitialSetupRoute: typeof InitialSetupRoute
  LinkRoute: typeof LinkRoute
  LoginRoute: typeof LoginRoute
  MathRoute: typeof MathRoute
  MigrationRoute: typeof MigrationRoute
  PrivacyRoute: typeof PrivacyRoute
  SettingsRoute: typeof SettingsRoute
  TipjarRoute: typeof TipjarRoute
  USharingCodeRoute: typeof USharingCodeRoute
  OauthFitbitCallbackRoute: typeof OauthFitbitCallbackRoute
  OauthWithingsCallbackRoute: typeof OauthWithingsCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tipjar': {
      id: '/tipjar'
      path: '/tipjar'
      fullPath: '/tipjar'
      preLoaderRoute: typeof TipjarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migration': {
      id: '/migration'
      path: '/migration'
      fullPath: '/migration'
      preLoaderRoute: typeof MigrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/math': {
      id: '/math'
      path: '/math'
      fullPath: '/math'
      preLoaderRoute: typeof MathRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link': {
      id: '/link'
      path: '/link'
      fullPath: '/link'
      preLoaderRoute: typeof LinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/initial-setup': {
      id: '/initial-setup'
      path: '/initial-setup'
      fullPath: '/initial-setup'
      preLoaderRoute: typeof InitialSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/build': {
      id: '/build'
      path: '/build'
      fullPath: '/build'
      preLoaderRoute: typeof BuildRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-deleted': {
      id: '/account-deleted'
      path: '/account-deleted'
      fullPath: '/account-deleted'
      preLoaderRoute: typeof AccountDeletedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$sharingCode': {
      id: '/u/$sharingCode'
      path: '/u/$sharingCode'
      fullPath: '/u/$sharingCode'
      preLoaderRoute: typeof USharingCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/withings/callback': {
      id: '/oauth/withings/callback'
      path: '/oauth/withings/callback'
      fullPath: '/oauth/withings/callback'
      preLoaderRoute: typeof OauthWithingsCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/fitbit/callback': {
      id: '/oauth/fitbit/callback'
      path: '/oauth/fitbit/callback'
      fullPath: '/oauth/fitbit/callback'
      preLoaderRoute: typeof OauthFitbitCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountDeletedRoute: AccountDeletedRoute,
  BuildRoute: BuildRoute,
  DashboardRoute: DashboardRoute,
  DemoRoute: DemoRoute,
  DownloadRoute: DownloadRoute,
  FaqRoute: FaqRoute,
  InitialSetupRoute: InitialSetupRoute,
  LinkRoute: LinkRoute,
  LoginRoute: LoginRoute,
  MathRoute: MathRoute,
  MigrationRoute: MigrationRoute,
  PrivacyRoute: PrivacyRoute,
  SettingsRoute: SettingsRoute,
  TipjarRoute: TipjarRoute,
  USharingCodeRoute: USharingCodeRoute,
  OauthFitbitCallbackRoute: OauthFitbitCallbackRoute,
  OauthWithingsCallbackRoute: OauthWithingsCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
